<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<li class="sub-nav-item">
  @if (navItem().isExternal) {
    <a class="sub-nav-item-link" [href]="navItem().route">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  } @else {
    <a
      class="sub-nav-item-link"
      [routerLink]="navItem().route"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{exact:false}"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }
  @if (navItem().children.length) {
    <ul class="sub-level-container">
      @for (item of navItem().children; track item.route) {
        <li class="sub-level-item">
          @if (item.isExternal) {
            <a class="sub-nav-item-link" [href]="item.route">{{ item.label }}</a>
          } @else {
            <a class="sub-nav-item-link" [routerLink]="item.route">{{ item.label }}</a>
          }
        </li>
      }
    </ul>
  }
</li>
